import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ShopFilledSvg from "@ant-design/icons-svg/es/asn/ShopFilled";
import AntdIcon from "../components/AntdIcon";
var ShopFilled = function ShopFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ShopFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ShopFilled.displayName = 'ShopFilled';
}
export default /*#__PURE__*/React.forwardRef(ShopFilled);